<template>
    <img
        :class="[$attrs.class]"
        class="rounded-lg object-cover"
        :src="url + '?format=webp'"
        loading="lazy"
        :alt="alt" />
</template>

<script setup lang="ts">
import type { ImageComponentModel } from '@su4r-frontend/api';

defineProps<ImageComponentModel>();
</script>
